import { Outlet } from "react-router-dom";
import PageDepth2 from "../components/PageDepth2";
import styles from '../styles/Proposal.module.css';
import data from "../data/data.json"
import classNames from "classnames/bind";
import PageTitle from "../components/PageTitle";

const cx = classNames.bind(styles);

//손해사정 제안
export default function Proposal() {

  const proposalCategory = data.category.find(
    (category) => category.path === "proposal"
  )

  return (
    <>
      <PageTitle title={proposalCategory.label} image={proposalCategory.image}/>

      <PageDepth2 pagedepth2={proposalCategory.children} />

      <Outlet/>
    </>
  );
}

